var overArg = require('./_overArg');

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;



//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/lodash/_getPrototype.js
// module id = 715
// module chunks = 168707334958949